import { useTranslation } from 'react-i18next'
// Прямой импорт, а не через бочку `@shared/ui`: она сама реэкспортирует
// этот модуль, и через неё вышел бы цикл.
import { Button } from '../Button/Button'
import { ButtonVariant } from '../Button/types'

/** Экран вместо упавшей страницы. Перезагрузка — единственное honest-действие:
 *  состояние поддерева после исключения доверия не заслуживает. */
export function ErrorFallback() {
  const { t } = useTranslation('common')

  return (
    <div className="flex min-h-100 flex-col items-center justify-center gap-4 p-8 text-center">
      <h2 className="typo-heading text-foreground">{t('error_boundary.title')}</h2>
      <p className="typo-base text-secondary max-w-100">{t('error_boundary.text')}</p>
      <Button type="button" variant={ButtonVariant.outline} onClick={() => location.reload()}>
        {t('error_boundary.reload')}
      </Button>
    </div>
  )
}
